module.exports = __webpack_public_path__ + "img/IMG_2785.f33eda65.gif";